import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaButtonDirective } from './da-button.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [DaButtonDirective],
    providers: [],
    exports: [DaButtonDirective]
})
export class DaButtonModule {}
